import React, { useState } from "react";

function TableComponentLevMang({
  columns,
  data,
  placeholder,
  height,
  setRowData,
  setApproveLeaveDialog,
}) {
  const [searchTerm, setSearchTerm] = useState("");
  const [sortedColumn, setSortedColumn] = useState(null);
  const [sortDirection, setSortDirection] = useState("asc");

  // Handle sorting when column header is clicked
  const handleSort = (column) => {
    if (sortedColumn === column) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortedColumn(column);
      setSortDirection("asc");
    }
  };
  return (
    <div
      className="table-container"
      style={{ height: "48vh", overflowY: "scroll" }}
    >
      {placeholder && (
        <div className="search-box">
          <input
            type="text"
            placeholder={placeholder}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      )}

      <div className="table-wrapper" style={{ height: height || "auto" }}>
        <table>
          <thead
            style={{
              backgroundColor: "#ffd8be",
              position: "sticky",
              top: "0",
            }}
          >
            <tr>
              {columns.map((col) => (
                <th key={col.accessor} onClick={() => handleSort(col.accessor)}>
                  {col.header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.length > 0 ? (
              data.map((row, index) => (
                <tr
                  key={index}
                  style={{
                    textAlign: "center",
                    backgroundColor:
                      (index + 1) % 2 === 0 ? "#ececec" : "white",
                  }}
                >
                  {columns.map((col) => (
                    <td key={col.accessorKey}>
                      {col.accessorKey === "actions" ? (
                        <button
                          className="action-btn"
                          onClick={() => {
                            setApproveLeaveDialog(true);
                            setRowData(row);
                          }}
                        >
                          Approve / Reject
                        </button>
                      ) : (
                        row[col.accessorKey]
                      )}
                    </td>
                  ))}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={columns.length} className="no-results">
                  No Results
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default TableComponentLevMang;
